"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remoteVideoSourcesDidChangeHandler = remoteVideoSourcesDidChangeHandler;
var _StudioLogger = require("@studio/logger/StudioLogger");
var _logger = require("../../../constants/logger");
var logger = new _StudioLogger.StudioLogger(_logger.loggerName);
function remoteVideoSourcesDidChangeHandler(videoSources, meetingSession, meetingResponse) {
  var meetingId = meetingResponse.Meeting.MeetingId;
  var logPayload = {
    chimeEventName: 'remoteVideoSourcesDidChange',
    'studio.meeting.id': meetingId,
    title: "Remote video sources did change: ".concat(JSON.stringify(videoSources))
  };
  logger.info(logPayload.title, logPayload);
}